import { IACDLEvent } from '../../../services/eventBus.service';

export const UserSettingsLoadedEventType = Symbol('USER_SETTINGS_LOADED_EVENT');

export class UserSettingsLoadedEvent implements IACDLEvent {
  readonly type: symbol = UserSettingsLoadedEventType;
}
